import React from "react";
import { LoaderIcon } from "react-hot-toast";
import { EmployerTransactionInfo } from "../../../models";
import DashboardStatsTile from "./dashboardStatsTile";

interface DashboardStatsProps {
  isEmployerTransactionInfoLoading: boolean;
  employerTransactionInfo: EmployerTransactionInfo | null;
  selectedMonthAndYear: Date | null;
  onMonthChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function DashboardStats({
  selectedMonthAndYear,
  onMonthChange,
  employerTransactionInfo,
  isEmployerTransactionInfoLoading,
}: DashboardStatsProps) {
  const currentDateAndTimeInISOString = new Date().toISOString();
  const formattedDate = currentDateAndTimeInISOString.substring(0, 19);

  return (
    <div>
      {/* INFO: Commenting Month and Year filter because number's are not matching  */}
      {/* <DashboardStatsHeader
        selectedMonthAndYear={selectedMonthAndYear}
        onMonthChange={onMonthChange}
      /> */}
      <div className="d-flex align-items-center justify-content-end mt-4">
        <p style={{ color: "var(--clr-text-secondary)" }}>Last Updated At: </p>
        <p style={{ color: "var(--clr-text-secondary)", marginLeft: "8px" }}>
          {formattedDate}
        </p>
      </div>
      {isEmployerTransactionInfoLoading ? (
        <ShowLoader />
      ) : (
        <DashboardStatsTile employerTransactionInfo={employerTransactionInfo} />
      )}
    </div>
  );
}

function ShowLoader() {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <LoaderIcon
        style={{
          height: "40px",
          width: "40px",
        }}
      />
    </div>
  );
}
